/* eslint-disable @angular-eslint/prefer-inject, @angular-eslint/prefer-standalone -- Shared page header retains its existing NgModule input contract. */
import {Component, Input}         from '@angular/core';
import {MatDialog}                from '@angular/material/dialog';
import {PurchaseCreditsComponent} from '@src/app/admin/settings/components/purchase-credits/purchase-credits.component';
import {AuthService}              from '@src/app/core/services/auth.service';
import {BillingPolicyService}     from '@src/app/core/services/billing-policy.service';
import {PermissionsService}       from '@src/app/core/services/permissions.service';
import {SettingsService}          from '@src/app/core/services/settings.service';
import {GlobalService}            from '@src/app/core/services/global.service';
import {Breadcrumb}               from '@src/app/shared/models/breadcrumb.model';
import {Button, ButtonMenuItem}   from '@src/app/shared/models/button.model';

@Component({
    standalone: false,
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent
{
    @Input() public title: string;
    @Input() public sandBoxMode: boolean;
    @Input() public breadcrumbs: Breadcrumb[];
    @Input() public buttons: Button[];
    @Input() public siteStatuses: any[];
    public activeSelection: any[] = [];

    public constructor(
        public globalService: GlobalService,
        public dialog: MatDialog,
        public authService: AuthService,
        public billingPolicies: BillingPolicyService,
        private permissionsService: PermissionsService,
        private settingsService: SettingsService,
    )
    {
    }

    public purchaseCredits(): void
    {
        const purchaseCreditModal = this.dialog.open(PurchaseCreditsComponent, {
            width: '60%',
            panelClass: 'mobile-width',
            disableClose: true,
            data: null,
        });
    }

    public callback(button: Button, optionalValue?: any): void
    {
        optionalValue ? button.callback(optionalValue) : button.callback();
    }

    public menuItemCallback(menuItem: ButtonMenuItem): void
    {
        menuItem.callback?.();
    }

    public shouldDisplayButton(button: Button): boolean
    {
        const hasPermission = !button.permission || this.permissionsService.can(button.permission);
        const pricingAllowed = !button.requiresPricingEnabled || this.settingsService.isPricingEnabled();

        return hasPermission && pricingAllowed;
    }

    public shouldDisplayMenuItem(menuItem: ButtonMenuItem): boolean
    {
        return !menuItem.permission || this.permissionsService.can(menuItem.permission);
    }

    public checkIfDisabled(id: number): boolean
    {
        if (this.globalService?.site?.status?.id == 7 || this.globalService?.site?.status?.id == 8) {
            if ([1, 5].includes(id)) {
                return false;
            }
        }

        if (this.globalService?.site?.status?.id == 6 && id == 5) {
            return false;
        }

        if (this.globalService?.site?.status?.id >= id) {
            return true;
        }

        if (this.globalService?.site?.status?.id == 1 && id != 2) {
            return true;
        }

        if (this.globalService?.site?.status?.id == 2 && id != 6) {
            return false;
        }

        if (this.globalService?.site?.status?.id != 5 && id == 6) {
            return true;
        }
    }

    public getSiteStatusByPhase(id?: number): any[]
    {
        return id
            ? this.siteStatuses.filter(c => c.phase?.id == id)
            : this.siteStatuses.filter(c => c.phase == null);
    }
}
